import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Modal, FadeIn, Emoji } from 'hosman-material';

import FeuArtifice from './components/FeuArtifice';
import ProgressBar from './components/ProgressBar';

import { updateMandate } from '../../../../../../../../../reducers/SellerApp/mandatesSlice';
import { partyPopper } from '../../../../../../../../../../shared/assets/emojis';

const SuccessAnimation = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { mandate, yousignStatus } = useSelector((state) => state.sellerMandates);
  const dispatch = useDispatch();
  const navigate = useNavigate();  
  const hasExecuted = useRef(false);
  const timeOutAfterSuccess = 6000;

  useEffect(() => {
    if (yousignStatus !== 'success' || hasExecuted.current) return;

    hasExecuted.current = true;

    setTimeout(() => {
      dispatch(updateMandate({
        mandateId: mandate.id, 
        params: { sign_status: 'incoming' }
      }))
      navigate(`/ev/ventes/${sale.id}`);
    }, timeOutAfterSuccess);
  }, [yousignStatus]);

  return (
    <div className='relative' data-testid='SuccessAnimation'>
      <Modal isOpen>
        <div className='p-6'>
          <div className='w-full absolute top-20 md:-top-16'>
            <FeuArtifice />
          </div>
          
          <FadeIn>
            <div className='flex flex-col items-center gap-3 text-center'>
              <div className='flex flex-col md:flex-row items-center gap-1'>
                <p className='h1 text-ih-blue'>Mandat signé, félicitations !</p>
                <Emoji emojiSrc={partyPopper} width='w-10' />
              </div>
              <div className='flex flex-col md:flex-row items-center gap-1'>
                <p className='text-ih-indigo'>Merci pour votre confiance, nous nous mettons dès maintenant au travail pour vendre votre bien au meilleur prix</p>
              </div>
            </div>
          </FadeIn>
          
          <ProgressBar timeOutAfterSuccess={timeOutAfterSuccess} />
        </div>
      </Modal>
    </div>
  );
}

export default SuccessAnimation;
